import React from "react";

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const UserManagementPagination = ({
  page = 1,
  totalPages = 1,
  perPage = 10,
  onPageChange,
  onPerPageChange,
  rowsPerPageLabel,
  pageLabel,
  previousLabel,
  nextLabel,
  direction = "ltr"
}) => {
  const safePage = Math.max(Number(page) || 1, 1);
  const safeTotalPages = Math.max(Number(totalPages) || 1, 1);

  return (
    <div className="user-management-pagination" dir={direction}>
      <label className="user-management-page-size">
        <span>{rowsPerPageLabel}</span>
        <select
          aria-label={rowsPerPageLabel}
          value={perPage}
          onChange={(event) => onPerPageChange(Number(event.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((value) => (
            <option key={value} value={value}>{value}</option>
          ))}
        </select>
      </label>
      <div
        className="user-management-pagination-center"
        data-testid="user-management-pager"
      >
        <button
          type="button"
          disabled={safePage <= 1}
          onClick={() => onPageChange(safePage - 1)}
        >
          {previousLabel}
        </button>
        <span>{pageLabel} {safePage} / {safeTotalPages}</span>
        <button
          type="button"
          disabled={safePage >= safeTotalPages}
          onClick={() => onPageChange(safePage + 1)}
        >
          {nextLabel}
        </button>
      </div>
      <div className="user-management-pagination-balance" aria-hidden="true" />
    </div>
  );
};

export default UserManagementPagination;
